module.exports = __webpack_public_path__ + "static/media/flamingo2.d4baf4c4.svg";